import { render, staticRenderFns } from "./CDMenuList.vue?vue&type=template&id=54e929c0&scoped=true"
import script from "./CDMenuList.vue?vue&type=script&lang=js"
export * from "./CDMenuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e929c0",
  null
  
)

export default component.exports